import styled from 'styled-components';
import { lightColorPalette } from '@linearb/linui-common';

export const StyledHeader = styled('h1')`
  color: #000;
  font-size: 56px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -1.68px;
  margin-bottom: 20px;
  margin-top: 0;
`;

export const StyledSubheader = styled('h2')`
  color: #565e6c;
  font-size: 24px;
  font-weight: 400;
  line-height: 125%;
`;

export const StyledListItemContent = styled.p`
  color: #565e6c;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
`;

export const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 26px;
  padding: 0;
`;

export const StyledListItem = styled.li`
  list-style: none;
  display: flex;
  flex-direction: row;
  gap: 30px;
  text-align: start;
  max-width: 320px;
`;

export const StyledContent = styled.main`
  background-color: ${lightColorPalette.lbWhite};
  flex-grow: 1;
  display: flex;
`;
